import { useState } from 'react';
import EmojiPicker from './EmojiPicker';
import { useNavigate } from 'react-router-dom';

function timeAgo(date) {
  const diff = (Date.now() - new Date(date)) / 1000;
  if (diff < 60) return "A l'instant";
  if (diff < 3600) return Math.floor(diff/60) + ' min';
  if (diff < 86400) return Math.floor(diff/3600) + 'h';
  if (diff < 604800) return Math.floor(diff/86400) + 'j';
  return new Date(date).toLocaleDateString('fr-FR');
}

export default function PostCard({ post, currentUserId, token, onUpdate, onDelete }) {
  const navigate = useNavigate();

  const renderTextWithMentions = (text) => {
    const parts = text.split(/(@\w+|https?:\/\/[^\s]+)/g);
    return parts.map((part, i) => {
      if (part.startsWith('@')) {
        const username = part.slice(1);
        return <span key={i} onClick={() => navigate('/membre/' + username)}
          style={{ color: '#8b1a2a', cursor: 'pointer', fontWeight: 600 }}>{part}</span>;
      }
      if (/^https?:\/\//.test(part)) {
        return <a key={i} href={part} target="_blank" rel="noopener noreferrer"
          style={{ color: '#8b1a2a', textDecoration: 'underline', wordBreak: 'break-all' }}>{part}</a>;
      }
      return part;
    });
  };
  const [showComments, setShowComments] = useState(false);
  const [commentText, setCommentText] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [likes, setLikes] = useState(post.likes?.length || 0);
  const [liked, setLiked] = useState(post.likes?.includes(currentUserId));

  const initiales = (post.author?.username || 'U').slice(0,2).toUpperCase();

  const handleLike = async () => {
    const res = await fetch('/api/posts/' + post._id + '/like', {
      method: 'PATCH', headers: { Authorization: 'Bearer ' + token }
    });
    if (res.ok) {
      const data = await res.json();
      setLikes(data.likes);
      setLiked(data.liked);
    }
  };

  const handleMentionInput = async (val) => {
    setCommentText(val);
    const match = val.match(/@(\w*)$/);
    if (match && match[1].length >= 1) {
      try {
        const res = await fetch('/api/auth/search?q=' + match[1], {
          headers: { Authorization: 'Bearer ' + token }
        });
        if (res.ok) {
          const data = await res.json();
          setSuggestions(data.slice(0, 5));
        }
      } catch {}
    } else {
      setSuggestions([]);
    }
  };

  const insertMention = (username) => {
    const newText = commentText.replace(/@\w*$/, '@' + username + ' ');
    setCommentText(newText);
    setSuggestions([]);
  };

  const handleComment = async () => {
    if (!commentText.trim()) return;
    const res = await fetch('/api/posts/' + post._id + '/comment', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
      body: JSON.stringify({ text: commentText })
    });
    if (res.ok) {
      const updated = await res.json();
      onUpdate && onUpdate(updated);
      setCommentText('');
      setSuggestions([]);
    }
  };

  const handleDelete = async () => {
    if (!window.confirm('Supprimer ce post ?')) return;
    await fetch('/api/posts/' + post._id, { method: 'DELETE', headers: { Authorization: 'Bearer ' + token } });
    onDelete && onDelete(post._id);
  };

  return (
    <div style={{ background: '#fff', border: '1px solid #e8d0d0', borderRadius: 10, padding: 16, marginBottom: 12 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
        <div style={{ width: 38, height: 38, borderRadius: '50%', background: '#e8c0c8', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 700, color: '#8b1a2a', overflow: 'hidden', flexShrink: 0 }}>
          {post.author?.photo ? <img src={post.author.photo} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : initiales}
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: '#1a1010', display: 'flex', alignItems: 'center', gap: 6 }}>
            {post.author?.username}
            <span style={{ fontSize: 12, background: post.type === 'auto' ? '#e8f0f5' : '#f5eeeb', color: post.type === 'auto' ? '#1a4a5a' : '#8b1a2a', padding: '1px 7px', borderRadius: 10, border: '1px solid ' + (post.type === 'auto' ? '#a8c8d8' : '#c49090') }}>
              {post.type === 'auto' ? 'Activite' : 'Post'}
            </span>
          </div>
          <div style={{ fontSize: 12, color: '#9a8080' }}>{timeAgo(post.createdAt)}</div>
        </div>
        {post.author?._id === currentUserId && (
          <button onClick={handleDelete} style={{ background: 'none', border: 'none', color: '#c49090', cursor: 'pointer', fontSize: 16 }}>x</button>
        )}
      </div>

      {post.type === 'auto' ? (
        <div style={{ fontSize: 12, color: '#666', background: '#fafaf8', border: '1px solid #e8d0d0', borderRadius: 8, padding: '10px 12px', marginBottom: 12 }}>
          {post.autoText}
        </div>
      ) : (
        <div>
          {post.text && <p style={{ fontSize: 13, color: '#1a1010', lineHeight: 1.7, marginBottom: post.imageUrl ? 12 : 0, whiteSpace: 'pre-wrap' }}>{renderTextWithMentions(post.text)}</p>}
          {post.imageUrl && <img src={post.imageUrl} alt="" style={{ width: '100%', borderRadius: 8, marginBottom: 12, display: 'block' }} />}
        </div>
      )}

      <div style={{ display: 'flex', gap: 16, paddingTop: 10, borderTop: '1px solid #e8d0d0' }}>
        <button onClick={handleLike} style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 12, color: liked ? '#8b1a2a' : '#9a8080', background: 'none', border: 'none', cursor: 'pointer', padding: '4px 8px', borderRadius: 6 }}>
          {liked ? '♥' : '♡'} {likes} j'aime
        </button>
        <button onClick={() => setShowComments(!showComments)} style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 12, color: '#9a8080', background: 'none', border: 'none', cursor: 'pointer', padding: '4px 8px', borderRadius: 6 }}>
          💬 {post.comments?.length || 0} commentaire{post.comments?.length !== 1 ? 's' : ''}
        </button>
      </div>

      {showComments && (
        <div style={{ marginTop: 10 }}>
          {post.comments?.map((c, i) => (
            <div key={i} style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
              <div style={{ width: 28, height: 28, borderRadius: '50%', background: '#e8c0c8', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 700, color: '#8b1a2a', flexShrink: 0, overflow: 'hidden' }}>
                {c.author?.photo ? <img src={c.author.photo} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : (c.author?.username || 'U').slice(0,2).toUpperCase()}
              </div>
              <div style={{ flex: 1, background: '#fafaf8', borderRadius: 8, padding: '6px 10px' }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: '#1a1010', marginBottom: 2 }}>{c.author?.username}</div>
                <div style={{ fontSize: 12, color: '#4a3030', lineHeight: 1.5 }}>{renderTextWithMentions(c.text)}</div>
              </div>
            </div>
          ))}

          {token && (
            <div style={{ marginTop: 6 }}>
              {suggestions.length > 0 && (
                <div style={{ background: '#fff', border: '1px solid #e8d0d0', borderRadius: 8, marginBottom: 4, overflow: 'hidden' }}>
                  {suggestions.map(u => (
                    <div key={u._id} onClick={() => insertMention(u.username)}
                      style={{ padding: '7px 12px', fontSize: 12, cursor: 'pointer', color: '#1a1010', borderBottom: '1px solid #f5eeeb' }}
                      onMouseEnter={e => e.currentTarget.style.background = '#f5eeeb'}
                      onMouseLeave={e => e.currentTarget.style.background = '#fff'}>
                      @{u.username}
                    </div>
                  ))}
                </div>
              )}
              <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                <input
                  value={commentText}
                  onChange={e => handleMentionInput(e.target.value)}
                  onKeyDown={e => e.key === 'Enter' && handleComment()}
                  placeholder="Ajouter un commentaire... (@pseudo pour mentionner)"
                  style={{ flex: 1, padding: '7px 12px', border: '1px solid #c49090', borderRadius: 20, fontSize: 12, background: '#fafaf8' }} />
                <EmojiPicker onEmojiClick={emoji => setCommentText(prev => prev + emoji)} />
                <button onClick={handleComment} style={{ padding: '7px 14px', borderRadius: 20, border: 'none', background: '#8b1a2a', color: '#fff', fontSize: 12, cursor: 'pointer' }}>→</button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
